import {observable} from "@legendapp/state";
import {DateTime, Duration} from "luxon";
import humanizeDuration from "humanize-duration";
import {plural} from "_utils/view";

export const $currentTime = observable(DateTime.local().toUTC());
setInterval(() => $currentTime.set(DateTime.now().toUTC()), 1000);


export function diff2human(time1: DateTime | string, time2: DateTime | string) {
    if (typeof time1 === 'string') {
        time1 = DateTime.fromISO(time1);
    }

    if (typeof time2 === 'string') {
        time2 = DateTime.fromISO(time2);
    }

    const diff = time1.diff(time2).shiftTo('minutes');

    return humanizeDuration(diff.toMillis(), {
        largest: 2,
        delimiter: ', ',
        spacer: ' ',
        conjunction: ' e ',
        serialComma: false,
        language: 'pt',
        round: true
    });
}

export function diff2time(time1: DateTime | string, time2: DateTime | string) {

    if(!time1 || !time2) {
        return '00:00';
    }

    if (typeof time1 === 'string') {
        time1 = DateTime.fromISO(time1, {zone: 'utc'});
    }

    if (typeof time2 === 'string') {
        time2 = DateTime.fromISO(time2, {zone: 'utc'});
    }
    const diff = time1.diff(time2).shiftTo('minutes');

    const millis = diff.toMillis();
    const seconds = Math.floor(millis / 1000);

    if (millis < 0) {
        return '00:00';
    }

    if (seconds >= 60 * 60 * 24) {
        const days = Math.floor(seconds / (60 * 60 * 24));
        return diff.toFormat(`d ${plural(days, "'dia'", "'dias'")}, hh:mm:ss`);
    }

    if (seconds >= 60 * 60) {
        return diff.toFormat('hh:mm:ss');
    }

    return diff.toFormat('mm:ss');
}


export function date2time(time1: DateTime | Duration) {
    return humanizeDuration(time1.toMillis(), {
        largest: 2,
        delimiter: ', ',
        spacer: ' ',
        conjunction: ' e ',
        serialComma: false,
        language: 'pt',
        round: true
    });
}
